import LineEnvelopeIcon from 'components/Luxkit/Icons/line/LineEnvelopeIcon'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import SupportNumberButton from '../../Luxkit/Button/SupportNumberButton'
import TextLink from '../../Luxkit/TextLink'
import BodyText from '../../Luxkit/Typography/BodyText'

const Container = styled(Sheet)`
  margin-top: ${rem(24)}; /* PLEASE DO NOT DO THIS! THIS IS JUST LEGACY. */
`

interface Props {
  heading?: string;
  description?: string;
  contactNumber?: App.GeoContact;
  email?: string;
  refCode?: string;
  onSupportEmailClick?: () => void;
  onSupportNumberClick?: () => void;
  waiverMessage?: string;
}

function HelpPane({ heading = 'Need help? Call our support team', description, contactNumber, email, refCode, onSupportEmailClick, onSupportNumberClick, waiverMessage }: Props) {
  return <Container background="neutral-six" borderRadius="M" padding={16}>
    <Group direction="vertical" gap={12}>
      <BodyText variant="large" weight="bold">{heading}</BodyText>
      <BodyText variant="medium">
        {description || 'Our customer service team are available anytime, 24 hours, 7 days a week'}
      </BodyText>
      <SupportNumberButton onClick={() => onSupportNumberClick?.()} currentContact={contactNumber} />
      {email && <div>
        <TextLink onClick={() => onSupportEmailClick?.()} startIcon={<LineEnvelopeIcon />} variant="black" href={`mailto:${email}`} rel="nofollow">{email}</TextLink>
      </div>}
      {refCode && <div>
        <BodyText variant="large" align="center" weight="bold">Reference Code</BodyText>
        <BodyText variant="large">{refCode}</BodyText>
      </div>}
      {waiverMessage && <BodyText variant="small" align="center">{waiverMessage}</BodyText>}
    </Group>
  </Container>
}

export default React.memo(HelpPane)
